import { Box } from "@mui/material";
import intermarkLogoR from "../../../assets/intermarkR.webp";
import intermarlLogoCollab_new from "../../../assets/intermark_3_1.png";
import intermarlLogoCollab_new_2 from "../../../assets/intermark_3_2.png";

export const IntermarkLogo = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden',
                height: 70
            }}
        >
            <Box
                component="img"
                src={intermarkLogoR}
                alt="IntermarkLogo"
                sx={{ height: 70, pt: 0.5, pb: 0.5, pr: 1 }}
            />
            <Box
                component="img"
                src={intermarlLogoCollab_new}
                alt="IntermarkLogo1"
                sx={{
                    height: 55, pt: 1, pb: 0.5,
                    display: {
                        xs: 'none', 
                        md: 'block'
                    },
                    '@media (max-width:902px)': {
                        height: 40
                    },
                    '@media (max-width:787px)': {
                        display: "none"
                    }
                 }}
            />
            <Box
                component="img"
                src={intermarlLogoCollab_new_2}
                alt="IntermarkLogo2"
                sx={{
                    height: 48, pt: 1, pb: 0.6, pl: 1.3,
                    display: {
                        xs: 'none', 
                        md: 'block'
                    },
                    '@media (max-width:1138px)': {
                        display: 'none',
                    }
                 }}
            />
            {/* <Box
                component="img"
                src={intermarkLogoCollab_UK}
                alt="Intermark UK"
                sx={{ width: 140, height: 80, pt: 0.1 }}
            /> */}
            {/* <Box
                component="img"
                src={intermarkLogoCollab_Cosmos}
                alt="Intermark CosmosStray"
                sx={{
                    height: 75,
                    display: {
                        xs: 'none', 
                        md: 'block'
                    },
                    '@media (max-width:943px)': {
                        display: 'none',
                    }
                }}
            /> */}
        </Box>
    );
};